// Persian numerals and price formatting.

const FA_DIGITS = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

/** Convert every ASCII digit in a value to its Persian equivalent. */
export const toFa = (value) =>
  String(value).replace(/\d/g, (d) => FA_DIGITS[+d]);

/** 1250000 -> "۱٬۲۵۰٬۰۰۰" (U+066C Arabic thousands separator) */
export const faNumber = (n) =>
  toFa(Math.round(Number(n) || 0).toLocaleString("en-US")).replace(/,/g, "٬");

/** 1250000 -> "۱٬۲۵۰٬۰۰۰ تومان" */
export const toman = (n) => `${faNumber(n)} تومان`;

/** Price after a percentage discount. */
export const salePrice = (price, discount) =>
  discount ? Math.round((price * (100 - discount)) / 100) : price;

/** Final payable price for a service record. */
export const finalPrice = (service) => salePrice(service.price, service.discount);

/** 45 -> "۴۵ دقیقه"  ·  180 -> "۳ ساعت"  ·  75 -> "۱ ساعت و ۱۵ دقیقه" */
export const duration = (mins) => {
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  if (!h) return `${toFa(m)} دقیقه`;
  if (!m) return `${toFa(h)} ساعت`;
  return `${toFa(h)} ساعت و ${toFa(m)} دقیقه`;
};

/** "۴٫۸" — Persian decimal separator is U+066B */
export const faRating = (n) => toFa(Number(n).toFixed(1)).replace(".", "٫");

export const faPercent = (n) => `${toFa(n)}٪`;
